import React from 'react';

import type { SVGProps } from 'react';

const CaretLastIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 10.5L4.35135 6L0 1.4L1.32432 0L7 6L1.32432 12L0 10.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 10.5L8.35135 6L4 1.4L5.32432 0L11 6L5.32432 12L4 10.5Z"
      fill="currentColor"
    />
  </svg>
);

export default CaretLastIcon;
